import "./TableCstmPs.scss";

const getNestedValue = (obj, path) => {
    if (!path) return undefined;

    return path
        .split(".")
        .reduce((acc, key) => acc?.[key], obj);
};

const TableCstmPs = ({
    columns = [],
    data = [],

    variant = "clean",

    rowKey = "id",
    className,
    emptyMessage = "No data available",

    rowClassName,
    cellClassName,

    onRowClick,
    onRowDoubleClick,

    layout = {},
    styleOptions = {},
}) => {

    const {
        stickyHeader = false,
        stickyFirstColumn = false,
        borderMode = "collapse",
    } = layout;

    const {
        shadow = false,
        rounded = false,
        striped = false,
        hoverable = false,
    } = styleOptions;

    const tableClassName = `table-cstm-ps ${className}
        variant-${variant} border-${borderMode}
        ${stickyHeader ? "sticky-header" : ""}
        ${stickyFirstColumn ? "sticky-first-column" : ""}
        ${shadow ? "shadow" : ""}
        ${rounded ? "rounded" : ""}
        ${striped ? "striped" : ""}
        ${hoverable ? "hoverable" : ""}
    `;

    const getCellValue = (row, accessor) => {

        if (typeof accessor === "function") {
            return accessor(row);
        }

        if (typeof accessor === "string") {
            return getNestedValue(row, accessor);
        }

        return undefined;
    };

    return (
        <div className="table-wrapper scroll">

            <table className={tableClassName}>

                {/* HEADER */}
                <thead>
                    <tr>
                        {columns.map((column, index) => (

                            <th
                                key={column.id || index}
                                className={
                                    typeof column.headerClassName === "function"
                                        ? column.headerClassName(column)
                                        : column.headerClassName || ""
                                }
                            >
                                {
                                    column.headerRender
                                        ? column.headerRender(column)
                                        : column.header
                                }
                            </th>

                        ))}
                    </tr>
                </thead>

                {/* BODY */}
                <tbody>

                    {
                        data.length === 0 ? (
                            <tr>
                                <td colSpan={columns.length}>
                                    {emptyMessage}
                                </td>
                            </tr>
                        ) : (
                            data.map((row, rowIndex) => {

                                const trClassName = typeof rowClassName === "function"
                                    ? rowClassName(row, rowIndex)
                                    : rowClassName || "";

                                return (
                                    <tr
                                        key={row[rowKey] || rowIndex}
                                        className={trClassName + (onRowClick || onRowDoubleClick ? 'click-cursor' : '')}

                                        onClick={() => onRowClick?.(row)}
                                        onDoubleClick={() => onRowDoubleClick?.(row)}
                                    >

                                        {
                                            columns.map((column, colIndex) => {

                                                const value = getCellValue(row, column.accessor);

                                                const content = column.render
                                                    ? column.render(value, row, column)
                                                    : value;

                                                const tdClassName = `${column.className || ""} ${typeof column.cellClassName === "function"
                                                        ? column.cellClassName(value, row, column)
                                                        : column.cellClassName || ""
                                                    }  ${typeof cellClassName === "function"
                                                        ? cellClassName(value, row, column)
                                                        : cellClassName || ""
                                                    } `;

                                                return (
                                                    <td
                                                        key={column.id || colIndex}
                                                        className={tdClassName}
                                                    >
                                                        {content}
                                                    </td>
                                                );
                                            })
                                        }

                                    </tr>
                                );
                            })
                        )
                    }

                </tbody>

            </table>

        </div>
    );
};

export default TableCstmPs;